import  {baseActions}  from "./base.actions";

export const certrequestActions = {
    add,
    edit,
    gets,
    get,
    delete: _delete,
    issuecertificate,
    setcertuniqueno,
    revokecertuniqueno,
    addcertificateprint,
    archivecertificate,
    deletecertificate,
    getblob,
    addquick
};

function add(obj,func=null) {
    
    return baseActions.add(obj,'certificationrequest',null,func)
}

function addquick(obj,func=null) {
    
    return baseActions.post(obj,'certificationrequest','CreateQuickCertificationRequest',null,func)
}

function edit(obj,id,func=null) {
    return baseActions.edit(obj,'certificationrequest',id,null,func);
}

function gets( page, perPage, sortField, sortOrder,filter) {
    return baseActions.gets('certificationrequest', page, perPage, sortField, sortOrder,filter);
}

function get(id)
{
    return baseActions.get('certificationrequest',id);
}


function getblob(controller,method,params)
{
    return baseActions.getBlob(controller,method,params);
}

function issuecertificate(id,func=null)
{
    return baseActions.post(null,'certificationrequest','issuecertificate'+'/'+id,null,func);
}

function archivecertificate(id,func=null)
{
    return baseActions.post(null,'certificationrequest','archivecertificate'+'/'+id,null,func);
}


function deletecertificate(id,func=null)
{
    return baseActions.post(null,'certificationrequest','deletecertificate'+'/'+id,null,func);
}

function addcertificateprint(id,func=null)
{
    return baseActions.post(null,'certificationrequest','addcertificateprint'+'/'+id,null,func);
}

function setcertuniqueno(model,func=null)
{
    return baseActions.post(model,'certificationrequest','setcertuniqueno',null,func);
}
function revokecertuniqueno(model,func=null)
{
    return baseActions.post(model,'certificationrequest','revokecertuniqueno',null,func);
}



function _delete(id,func=null)
{
    return baseActions.delete(id,'certificationrequest',func);
}